import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17a3e92a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("全局搜索")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消搜索")
const _hoisted_10 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("搜索名称")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("搜索说明")
const _hoisted_15 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_16 = { class: "card-body table-responsive p-0" }
const _hoisted_17 = {
  key: 0,
  class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center"
}
const _hoisted_18 = { ref: "tableTr" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "ID", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "操作", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "influenceStatus" }, "状态", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "influenceName" }, "名称", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "influenceRemark",
  class: "normal-width text-left"
}, "说明", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createName" }, "创建姓名", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createTime" }, "创建时间", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyName" }, "修改姓名", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyTime" }, "修改时间", -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["colspan"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_31 = { class: "table-btn-group" }
const _hoisted_32 = { class: "btn-group" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "text-left" }
const _hoisted_40 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_41 = { class: "content-modal" }
const _hoisted_42 = { class: "row" }

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_dropdown_search = _resolveComponent("app-dropdown-search")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_app_table_page = _resolveComponent("app-table-page")
  const _component_app_alert = _resolveComponent("app-alert")
  const _component_app_select_level = _resolveComponent("app-select-level")
  const _component_app_draggable_listview = _resolveComponent("app-draggable-listview")
  const _component_app_select_from_db = _resolveComponent("app-select-from-db")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_textarea = _resolveComponent("app-textarea")
  const _component_app_switch_number = _resolveComponent("app-switch-number")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.Auth('/aftersale/ticket/influence/add'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.addModalOpen && _ctx.addModalOpen(...args)))
                  }, [
                    _createVNode(_component_svg_icon, { name: "add" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.Auth('/aftersale/ticket/influence/levelSelect'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.influenceParentIdLevelModalOpen && _ctx.influenceParentIdLevelModalOpen(...args)))
                  }, [
                    _createVNode(_component_svg_icon, { name: "list-outline" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.Auth('/aftersale/ticket/influence/list'))
                ? (_openBlock(), _createBlock(_component_app_dropdown_search, {
                    key: 0,
                    ref: "tableSearch",
                    modelValue: _ctx.tableRequestItem.searchKey,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.tableRequestItem.searchKey) = $event)),
                    searchFunction: _ctx.searchFunction,
                    disabledTableExport: !_ctx.Auth('/aftersale/ticket/influence/export')
                  }, {
                    "dropdown-search-menu": _withCtx(() => [
                      _createElementVNode("li", {
                        class: "dropdown-item hyper-text-themes hand",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.searchFunction('all')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-sharp",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_8
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.searchCancel()))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_9
                      ]),
                      (_ctx.tableRequestItem.lockItem)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tableRequestItem.lockItem, (item, key, i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                              (i===0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                                : _createCommentVNode("", true),
                              _createElementVNode("li", {
                                class: _normalizeClass([item.value?'hyper-text-themes':'', "dropdown-item hand"]),
                                onClick: item.openFn
                              }, [
                                _createVNode(_component_svg_icon, {
                                  name: item.value?'radio-button-on':'radio-button-off',
                                  class: "mt-0 mr-1"
                                }, null, 8, ["name"]),
                                _createTextVNode(" " + _toDisplayString(item.title), 1)
                              ], 10, _hoisted_11)
                            ], 64))
                          }), 128))
                        : _createCommentVNode("", true),
                      _hoisted_12,
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[4] || (_cache[4] = $event => (_ctx.searchFunction('influence_name')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_13
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[5] || (_cache[5] = $event => (_ctx.searchFunction('influence_remark')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_14
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "searchFunction", "disabledTableExport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.tableRequestItem.dateTime,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.tableRequestItem.dateTime) = $event)),
                type: "datetimerange",
                shortcuts: _ctx.dateTimeShortcuts,
                size: "large",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                onChange: _cache[8] || (_cache[8] = $event => (_ctx.searchFunction('search')))
              }, null, 8, ["modelValue", "shortcuts"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.Auth('/aftersale/ticket/influence/list'))
              ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_18, [
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21,
                      _createElementVNode("th", {
                        field: "influenceParentName",
                        class: "table-search-lock hand active",
                        onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.influenceParentIdLevelModalOpen && _ctx.influenceParentIdLevelModalOpen(...args)))
                      }, "上级影响范围"),
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27
                    ], 512)
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.tableItems.length<1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                          _createElementVNode("td", {
                            colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                          }, [
                            _createVNode(_component_svg_icon, { name: "alert" }),
                            _hoisted_30
                          ], 8, _hoisted_29)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.influenceId,
                        class: _normalizeClass({'text-red': parseInt(item.influenceStatus)===2})
                      }, [
                        _createElementVNode("td", null, _toDisplayString(((_ctx.tablePageItems.current-1) * _ctx.tablePageItems.size) + i + 1), 1),
                        _createElementVNode("td", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            (_ctx.Auth('/aftersale/ticket/influence/mod'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "btn btn-themes",
                                  onClick: $event => (_ctx.modModalOpen(item))
                                }, [
                                  _createVNode(_component_svg_icon, { name: "settings-outline" })
                                ], 8, _hoisted_33))
                              : _createCommentVNode("", true),
                            (_ctx.Auth('/aftersale/ticket/influence/del'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "btn btn-themes",
                                  onClick: $event => (_ctx.delAlert(item))
                                }, [
                                  _createVNode(_component_svg_icon, { name: "trash-outline" })
                                ], 8, _hoisted_34))
                              : _createCommentVNode("", true),
                            (_ctx.Auth('/aftersale/ticket/influence/sort'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  type: "button",
                                  class: "btn btn-themes",
                                  onClick: $event => (_ctx.sortListView(item))
                                }, [
                                  _createVNode(_component_svg_icon, { name: "git-compare-outline" })
                                ], 8, _hoisted_35))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (parseInt(item.influenceStatus)===1)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              class: "hand",
                              onClick: $event => (_ctx.toggleStatus(item))
                            }, [
                              _createVNode(_component_svg_icon, {
                                name: "checkmark-circle-outline",
                                class: "hyper-text-themes"
                              })
                            ], 8, _hoisted_36))
                          : (parseInt(item.influenceStatus)===2)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 1,
                                class: "hand",
                                onClick: $event => (_ctx.toggleStatus(item))
                              }, [
                                _createVNode(_component_svg_icon, {
                                  name: "close-circle-outline",
                                  class: "text-red"
                                })
                              ], 8, _hoisted_37))
                            : (_openBlock(), _createElementBlock("td", _hoisted_38, "未知")),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.influenceParentId.value? 'active' : ''])
                        }, _toDisplayString(item.influenceParentName), 3),
                        _createElementVNode("td", null, _toDisplayString(item.influenceName), 1),
                        _createElementVNode("td", _hoisted_39, _toDisplayString(item.influenceRemark), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyTime), 1)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_app_table_page, {
            class: "card-footer",
            pageItems: _ctx.tablePageItems,
            pageFunction: _ctx.getList
          }, null, 8, ["pageItems", "pageFunction"]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_41, [
      _createVNode(_component_app_alert, { ref: "delModal" }, null, 512),
      _createVNode(_component_app_select_level, {
        ref: "influenceParentIdLevel",
        levelType: "select",
        levelApi: _ctx.API,
        selectItem: _ctx.tableRequestItem.lockItem.influenceParentId,
        selectFunction: _ctx.influenceParentIdLevelFunction,
        searchFieldList: _ctx.influenceParentIdLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_draggable_listview, {
        ref: "sortModal",
        modelValue: _ctx.editSortList,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.editSortList) = $event)),
        group: "influence",
        title: _ctx.editSortTitle,
        submitFunction: _ctx.tableSortSubmit
      }, null, 8, ["modelValue", "title", "submitFunction"]),
      _createVNode(_component_app_modal, {
        ref: "editModal",
        title: _ctx.editModalTitle,
        submitButtonName: _ctx.editModalSubmitButtonName,
        size: "lg",
        submitFunction: _ctx.editModalSubmit,
        submitAfterClose: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-12",
              label: "上级影响范围",
              modelValue: _ctx.editModalItem.influenceParentId,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.editModalItem.influenceParentId) = $event)),
              searchApi: _ctx.influenceParentIdSelectApi
            }, null, 8, ["modelValue", "searchApi"]),
            _createVNode(_component_app_input, {
              class: "col-lg-12",
              label: "名称",
              modelValue: _ctx.editModalItem.influenceName,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.editModalItem.influenceName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_textarea, {
              class: "col-lg-12",
              label: "说明",
              modelValue: _ctx.editModalItem.influenceRemark,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.editModalItem.influenceRemark) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_switch_number, {
              class: "col-lg-12",
              label: "状态",
              modelValue: _ctx.editModalItem.influenceStatus,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.editModalItem.influenceStatus) = $event)),
              enableName: "启用",
              disabledName: "禁用"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["title", "submitButtonName", "submitFunction"])
    ])
  ]))
}